import partnerImageOrganizations from '@/assets/images/support-veterans.webp';
import partnerImageBusiness from '@/assets/images/support-volunteers.webp';
import supportChildren from '@/assets/images/support-children.webp';

export const SUPPORT_US_DATA = {
    PARTNERS_DATA: [
        {
            id: 'organizations',
            IMG: partnerImageOrganizations,
            ALT: 'Ветеранка обіймає коня',
        },
        {
            id: 'business',
            IMG: partnerImageBusiness,
            ALT: 'Волонтерка поруч із конем',
        },
        {
            id: 'people',
            IMG: supportChildren,
            ALT: 'Діти, які отримують підтримку',
        },
    ],
};
